import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbAssetsReportsRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-assets-reports-default-redirect',
	path: '/jira/servicedesk/assets/reports',
	exact: true,
};
